export default "__VITE_ASSET__DWPY6zfQ__"